import Vue from 'vue'
import {mapGetters} from 'vuex'

import template from './_app-logo.pug'

const Logo = require('assets/images/logoGCazul.png')

// @vue/component
export default Vue.extend({
  template: template(),

  data() {
    return {
      logo: Logo
    }
  }
})
